import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  // mode: 'history',
  // scrollBehavior(to, from, savedPosition) {
  //   if (to.hash) {
  //     return {
  //       selector: to.hash
  //     }
  //   }
  // },
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      component: resolve => require(['@/pages/login/login'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/register',
      component: resolve => require(['@/pages/login/register'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/agreenment',
      component: resolve => require(['@/pages/login/agreenment'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/solution',
      component: resolve => require(['@/pages/about/solution'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/forget/password',
      component: resolve => require(['@/pages/login/forget'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/home',
      component: resolve => require(['@/pages/home/index'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/goods/details',
      component: resolve => require(['@/pages/goods/details'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/area',
      component: resolve => require(['@/pages/theme/area'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/theme',
      component: resolve => require(['@/pages/theme/theme'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/theme/list',
      component: resolve => require(['@/pages/theme/list'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/cart',
      component: resolve => require(['@/pages/cart/cart'], resolve),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/order',
      component: resolve => require(['@/pages/order/order'], resolve),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/order/pay',
      component: resolve => require(['@/pages/order/pay'], resolve),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/wechat',
      component: resolve => require(['@/pages/order/wechatpay'], resolve),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/search',
      component: resolve => require(['@/pages/search/search'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/brand',
      component: resolve => require(['@/pages/brand/brand'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/brand/goods',
      component: resolve => require(['@/pages/brand/goods'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/settings',
      component: resolve => require(['@/pages/settings/publicSet'], resolve),
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/settings/person',
          component: resolve => require(['@/pages/settings/person'], resolve),
          meta: {
            requireAuth: true,
            name: '个人中心'
          },
        },
        {
          path: '/wallet',
          component: resolve => require(['@/pages/wallet/wallet'], resolve),
          meta: {
            requireAuth: true,
            name: '我的钱包'
          }
        },
        {
          path: '/wallet/logs',
          component: resolve => require(['@/pages/wallet/logs'], resolve),
          meta: {
            requireAuth: true,
            name: '我的钱包'
          }
        },
        {
          path: '/settings/infomation',
          component: resolve => require(['@/pages/settings/infomation'], resolve),
          meta: {
            requireAuth: true,
            name: '个人信息'
          }
        },
        {
          path: '/news',
          component: resolve => require(['@/pages/news/list'], resolve),
          meta: {
            requireAuth: true,
            name: '消息通知'
          }
        },
        {
          path: '/news/details/:id',
          component: resolve => require(['@/pages/news/details'], resolve),
          meta: {
            requireAuth: true,
            name: '消息通知'
          }
        },
        {
          path: '/goods/collection',
          component: resolve => require(['@/pages/goods/collection'], resolve),
          meta: {
            requireAuth: true,
            name: '商品收藏'
          }
        },
        {
          path: '/goods/foot',
          component: resolve => require(['@/pages/goods/footPrint'], resolve),
          meta: {
            requireAuth: true,
            name: '我的足迹'
          }
        },
        {
          path: '/settings/security',
          component: resolve => require(['@/pages/settings/security'], resolve),
          meta: {
            requireAuth: true,
            name: '安全设置'
          }
        },
        // {
        //   path: '/settings/tel',
        //   component: resolve => require(['@/pages/settings/modifyTel'], resolve),
        //   meta: {
        //     requireAuth: true,
        //     name: '安全设置'
        //   }
        // },
        {
          path: '/settings/paypsd',
          component: resolve => require(['@/pages/settings/setPayPsd'], resolve),
          meta: {
            requireAuth: true,
            name: '安全设置'
          }
        },
        {
          path: '/settings/loginpsd',
          component: resolve => require(['@/pages/settings/modifyLogin'], resolve),
          meta: {
            requireAuth: true,
            name: '安全设置'
          }
        },
        {
          path: '/settings/paypsd/modify',
          component: resolve => require(['@/pages/settings/modifyPay'], resolve),
          meta: {
            requireAuth: true,
            name: '安全设置'
          }
        },
        {
          path: '/settings/email',
          component: resolve => require(['@/pages/settings/email'], resolve),
          meta: {
            requireAuth: true,
            name: '安全设置'
          }
        },
        {
          path: '/settings/verified',
          component: resolve => require(['@/pages/settings/verified'], resolve),
          meta: {
            requireAuth: true,
            name: '安全设置'
          }
        },
        {
          path: '/order/list',
          component: resolve => require(['@/pages/order/list'], resolve),
          meta: {
            requireAuth: true,
            name: '我的订单'
          }
        },
        {
          path: '/order/details',
          component: resolve => require(['@/pages/order/details'], resolve),
          meta: {
            requireAuth: true,
            name: '我的订单'
          }
        },
        {
          path: '/inquire/list',
          component: resolve => require(['@/pages/cooperate/inquireList'], resolve),
          meta: {
            requireAuth: true,
            name: '我的咨询'
          }
        },
        {
          path: '/sale',
          component: resolve => require(['@/pages/goods/sale'], resolve),
          meta: {
            requireAuth: true,
            name: '售后服务'
          }
        },
        {
          path: '/sale/details/1',
          component: resolve => require(['@/pages/goods/saleDetails'], resolve),
          meta: {
            requireAuth: true,
            name: '售后服务'
          }
        },
        {
          path: '/settings/address',
          component: resolve => require(['@/pages/settings/address'], resolve),
          meta: {
            requireAuth: true,
            name: '地址管理'
          }
        },
        {
          path: '/settings/invoice',
          component: resolve => require(['@/pages/settings/invoice'], resolve),
          meta: {
            requireAuth: true,
            name: '发票管理'
          }
        },
      ]
    },
    {
      path: '/bulletin',
      component: resolve => require(['@/pages/news/index'], resolve),
      meta: {
        requireAuth: false,
        name: '商城快报'
      }
    },
    {
      path: '/cooperate',
      component: resolve => require(['@/pages/cooperate/cooperate'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/inquiry',
      component: resolve => require(['@/pages/cooperate/inquiry'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/help',
      component: resolve => require(['@/pages/help/index'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/help/type',
      component: resolve => require(['@/pages/help/question'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/help/details',
      component: resolve => require(['@/pages/help/details'], resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/feedback',
      component: resolve => require(['@/pages/help/feedback'], resolve),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js